import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M5 8V5c0-1 1-2 2-2h10c1 0 2 1 2 2v3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M19 16v3c0 1-1 2-2 2H7c-1 0-2-1-2-2v-3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "4", x2: "20", y1: "12", y2: "12", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "SplitSquareVertical";
const SplitSquareVertical = memo(themed(Icon));
export {
  SplitSquareVertical
};
//# sourceMappingURL=split-square-vertical.js.map
